<mat-dialog-content>
  <h3>Kies een teller:</h3>
  <div class="col-md-6">
    <mat-form-field appearance="fill">
      <mat-label>Teller</mat-label>
      <mat-select [(ngModel)]="counter">
        <mat-option>Geen</mat-option>
        @for (player of data.availableCounters; track player.playerId) {
          <mat-option [value]="player.playerId">
            {{ player.name }}
          </mat-option>
        }
        <mat-option [value]="999999">
          Invalteller
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (counter) {
    <button mat-button [mat-dialog-close]="{counter: counter}">Opslaan</button>
  }
  <button mat-button (click)="onAnnulerenClick()">Annuleren</button>
</mat-dialog-actions>
